import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import { useDispatch } from "react-redux";

const initialState = {
  isLoading: true,
  viewSingleProduct: {},
  isAddViewModalOpen: false,
  isAddEditModalOpen: false,
  isAddDeleteModalOpen: false,
  isSuccess: false,
  isError: false,
  message: "",
  response: {},
  productId: "",
};

export const addProduct = createAsyncThunk(
  "products/add_product",
  async (productDetails, thunkAPI) => {
    console.log("product detail", productDetails);
    const {
      isWeightVariable,
      otherProductInfo,
      productAmount,
      productBenefits,
      productBrand,
      productCategory,
      productDescription,
      productDiscountPercentage,
      productDiscountPrice,
      productImage,
      productTag,
      productName,
      storageAndUsage,
      productType,
      productSlug,
    } = productDetails;
    try {
      const formData = new FormData();
      formData.append("product_name", productName);
      formData.append("product_amount", productAmount);
      formData.append("product_discount_price", productDiscountPrice);
      formData.append("category_id", productCategory);
      formData.append("other_product_info", otherProductInfo);
      formData.append("product_discount_percent", productDiscountPercentage);
      formData.append("description", productDescription);
      formData.append("tag", productTag);
      formData.append("is_weight_variable", isWeightVariable);
      formData.append("brand", productBrand);
      formData.append("benefits", productBenefits);
      formData.append("storage_and_usage", storageAndUsage);
      formData.append("product_type", productType);
      formData.append("product_slug", productSlug);
      formData.append("product_image", productImage);

      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/product/add_product`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const addProductSlice = createSlice({
  name: "addProducts",
  initialState,
  reducers: {
    viewAddProduct: (state, action) => {
      state.isAddViewModalOpen = true;
      state.viewSingleProduct = action.payload;
    },
    openAddDeleteModal: (state, action) => {
      state.isAddDeleteModalOpen = true;
      state.viewSingleProduct = action.payload;
    },
    closeAddModal: (state, action) => {
      state.isAddViewModalOpen = false;
      state.isAddDeleteModalOpen = false;
      state.isAddEditModalOpen = false;
      state.viewSingleProduct = {};
    },
    editAddProduct: (state, action) => {
      state.isAddEditModalOpen = true;
      state.viewSingleProduct = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addProduct.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addProduct.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.isError = false;
      state.message = action.payload.message;
      state.response = action.payload;
      state.productId = action.payload?.result?.affectedRows?.id;
    });
    builder.addCase(addProduct.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = true;
      state.message = action.payload.message;
      state.response = action.payload;
      console.error(action.error);
    });
  },
});
export const {
  viewAddProduct,
  openAddDeleteModal,
  closeAddModal,
  editAddProduct,
} = addProductSlice.actions;
export default addProductSlice.reducer;
